module.exports = {
    DEFAULT_LIMIT: 10,
    CURRENT_PAGE: 1,
    PAGE_OPTION: [{ id: 10, name: "Hiển thị 10 dòng", value: 10, text: "Hiển thị 10 dòng" }, { id: 30, name: "Hiển thị 30 dòng", value: 30, text: "Hiển thị 30 dòng" }, { id: 50, name: "Hiển thị 50 dòng", value: 50, text: "Hiển thị 50 dòng" }],
    DEFAULT_ERROR_MESSAGE: 'Có lỗi xảy ra - vui lòng thử lại'
}